// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1_Ux_","cls2":"RelatedPapers-cls2_piO RelatedPapers-cls1_Ux_"};